import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Mecidiyeköy Koltuk Yıkama", path: "/sisli/mecidiyekoy-koltuk-yikama" },
  { label: "Mecidiyeköy Yorgan Yıkama", path: "/sisli/mecidiyekoy-yorgan-yikama" },
  { label: "Osmanbey Koltuk Yıkama", path: "/sisli/osmanbey-koltuk-yikama" },
  { label: "Osmanbey Battaniye Yıkama", path: "/sisli/osmanbey-battaniye-yikama" },
  { label: "Halaskargazi Koltuk Yıkama", path: "/sisli/halaskargazi-koltuk-yikama" },
  { label: "Halaskargazi Perde Yıkama", path: "/sisli/halaskargazi-perde-yikama" },
  { label: "Feriköy Koltuk Yıkama", path: "/sisli/ferikoy-koltuk-yikama" },
  { label: "Feriköy Yerinde Yıkama", path: "/sisli/ferikoy-yerinde-yikama" },
  { label: "Bozkurt Mahallesi Koltuk Yıkama", path: "/sisli/bozkurt-koltuk-yikama" },
  { label: "Bozkurt Mahallesi Kuru Temizleme", path: "/sisli/bozkurt-kuru-temizleme" },
  { label: "Şişli Merkez Koltuk Yıkama", path: "/sisli/merkez-koltuk-yikama" }
];

const SisliServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          ŞİŞLİ HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default SisliServiceArea;
